import { isString, isFunction, isEmpty, isObject } from './utils'

/**
 * @param {string} handlerName
 * @returns {Function}
 */
const buildWatchError = handlerName => {
  return function (val) {
    const handler = this.$options[handlerName]

    if (val === false || isEmpty(handler)) {
      return
    }

    if (isString(handler)) {
      this[handler](val)
      return
    }

    if (isFunction(handler)) {
      handler.call(this, val)
      return
    }

    if (isObject(handler)) {
      this.$router.replace(handler)
    }
  }
}

export { buildWatchError }
